import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=6369276b&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6369276b')) {
      api.createRecord('6369276b', component.options)
    } else {
      api.reload('6369276b', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=6369276b&", function () {
      api.rerender('6369276b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21y67tErl5yTr/JS/offershelp.vue"
export default component.exports